import { render, staticRenderFns } from "./ElementComposition.vue?vue&type=template&id=a8a5c14a&"
import script from "./ElementComposition.vue?vue&type=script&lang=js&"
export * from "./ElementComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports